<template>
  <van-tabbar route :active-color="activeColor" inactive-color="#fff" class="tabbar">
    <van-tabbar-item v-for="(item, index) of tabList" :key="index" replace :to="item.path" :name="index">
      <span>{{ item.name }}</span>
      <template #icon="props">
        <svg-icon :iconClass="item.icon" :style="{color: props.active ? activeColor : '#fff' }"></svg-icon>
        <!-- <img :src="props.active ? activeColor : item.icon.inactive" /> -->
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
// import tabbar from '@/router/routes/tabbarRoute.js'
export default {
  props: {
    activeColor: {
      type: String,
      default: '#DB1905',
    },
    tabList: {
      type: Array,
      default: () => [],
    }
  },
  data () {
    return {
      active: 0,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true,
    };
  },
  mounted () {
    window.onresize = () => {
      if (this.clientHeight > document.documentElement.clientHeight) {
        this.showBtn = false;
      } else {
        this.showBtn = true;
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.van-tabbar {
  height: 1rem;
}
.van-tabbar-item--active {
  background: none;
  color: #fff;
}
.tabbar{
 background: url('~@/assets/Tabbar/tabbar-bg.png') no-repeat 50%/100%;
}
</style>